// const basename = '/backend/canary-website';
const basename = '/';

export {basename};